
import { Options, Vue } from "vue-class-component";

@Options({
  methods: {
    openPopup(url: string) {
      window.open(url, "Partager", "left=100,top=100,width=700,height=400");
    },
  },
})
export default class SharePopup extends Vue {
  url = window.location.href;
}
